import { Link } from "react-router-dom";
import Logo from "./Logo";
import { companyLinks, supportLinks } from "../data/content";
import { useSiteContent } from "../siteContent";

function FooterLink({ item, company }) {
  if (item.external) {
    const href = item.name.startsWith("Bus tickets") ? company.busWebsiteHref : item.href;
    return (
      <a href={href} target="_blank" rel="noreferrer" className="hover:text-white">
        {item.name}
      </a>
    );
  }
  return (
    <Link to={item.path} className="hover:text-white">
      {item.name}
    </Link>
  );
}

export default function SiteFooter() {
  const { company } = useSiteContent();
  return (
    <footer className="bg-[#0B6A34] text-[#d7eadc]">
      <div className="container-page grid gap-10 py-12 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="inline-flex rounded-md bg-white px-2 py-1.5">
            <Logo className="h-10 w-auto max-w-[9rem] object-contain" />
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed">{company.tagline}</p>
        </div>

        <div>
          <h2 className="text-xs font-bold uppercase tracking-[0.16em] text-[#b7e7a8]">Support</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            {supportLinks.map((item) => (
              <li key={item.name}>
                <FooterLink item={item} company={company} />
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-xs font-bold uppercase tracking-[0.16em] text-[#b7e7a8]">Company</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            {companyLinks.map((item) => (
              <li key={item.name}>
                <FooterLink item={item} company={company} />
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-xs font-bold uppercase tracking-[0.16em] text-[#b7e7a8]">Reach us</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              Cargo helpline:{" "}
              <a href={company.phoneHref} className="hover:text-white">
                {company.phone}
              </a>
            </li>
            <li>
              <a href={company.emailHref} className="hover:text-white">
                {company.email}
              </a>
            </li>
            <li>
              <a href={company.websiteHref} target="_blank" rel="noreferrer" className="hover:text-white">
                {company.website}
              </a>
            </li>
            <li>Head office: {company.headOffice}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="container-page flex flex-col gap-2 py-4 text-xs text-[#c5dfcb] sm:flex-row sm:items-center sm:justify-between">
          <p>© Essaar. All rights reserved.</p>
          <p>GSTIN {company.gstin}</p>
        </div>
      </div>
    </footer>
  );
}
